
// import UdidPage from './views/pages/udid';
// import MainPage from "./views/pages/main";
import { LangContext } from './context';
import { Route, Routes, BrowserRouter } from "react-router-dom";
import { useState, useEffect } from 'react';
import translations from './utils/Translations';
// import BuyPage from './views/pages/buy';
import PaymentForm from './views/pages/pay';
import UDIDDeviceStatus from './views/pages/get_udid';

function App() {
  const [browserLanguage, setBrowserLanguage] = useState('');
  const [Lang, setLang] = useState('en')
  useEffect(() => {
        const browserLang = navigator.language || navigator.languages[0];
        setBrowserLanguage(browserLang);
        const langCode = browserLang.substring(0, 2);
        if (translations[langCode]) {
          setLang(langCode);
        } else {
          setLang('en');
      }
    }, []);

  return (

    <LangContext.Provider value={{
      Lang, setLang
    }}>
       <BrowserRouter>
        <Routes>
          {/* <Route path="/" element={<MainPage />} />
          <Route path="/UDiD" element={<UdidPage />} />
          <Route path="/UDiD/:udid" element={<UdidPage />} />
          <Route path="/buy" element={<BuyPage />} /> */}
          <Route path="/pay/:pay_id" element={<PaymentForm />} />
          <Route path="/get/" element={<UDIDDeviceStatus />} />
        </Routes>
      </BrowserRouter>
    </LangContext.Provider>
  );
}

export default App;
